import {CreateButton} from "react-admin";
import * as React from "react";

const CreateGradientButtonMod = props => {
    return (
        <CreateButton className="button gradient-button" label={props.label} />
    );
};

export default CreateGradientButtonMod;